// 支援岗位

const supportPostDlg = {
  namespaced: true,

  state: {
    dlgShow: false,

    postId: "",

    postInfo: ""
  },

  getters: {
    dlgShow: state => state.dlgShow,

    postId: state => state.postId,

    postInfo: state => state.postInfo
  },

  mutations: {
    SET_DLGSHOW: (state, val) => {
      state.dlgShow = val;
    },

    SET_POSTTYPE: (state, val) => {
      state.postType = val;
    },

    SET_POSTINFO: (state, val) => {
      state.postInfo = val;
    }
  },

  actions: {}
};

export default supportPostDlg;
